'use strict';
var _gaq = _gaq || [];
angular.module('analytics', []).run(['$http', function ($http) {
        var devId = 'UA-60171446-2';
        var productionId = 'UA-60171446-1';
        console.log('analytics', document.location);
        var id = productionId;
        if (document.location.origin.indexOf('localhost:') > -1) {
            id = devId;
        }
        _gaq.push(['_setAccount', id]);
        _gaq.push(['_trackPageview']);
        var ga = document.createElement('script');
        ga.type = 'text/javascript';
        ga.async = true;
        ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(ga, s);
    }]).service('analytics', function ($rootScope, $window, $location, $routeParams) {
    // var convertPathToQueryString = function(path, $routeParams) {
    //     return path;
    //     console.log('convertPathToQueryString', path);
    //     for (var key in $routeParams) {
    //         var queryParam = '/' + $routeParams[key];
    //         path = path.replace(queryParam, '');
    //     }
    //
    //     var querystring = decodeURIComponent($.param($routeParams));
    //
    //     if (querystring === '') return path;
    //
    //     return path; //+ "?" + querystring;
    // };
    var track = function () {
        $window._gaq.push(['_trackPageview', $location.path()]);
    };
    $rootScope.$on('$routeChangeStart', track);
});
//# sourceMappingURL=analytics.js.map